define('views/pages/news/tags',['require','views/base/view','views/base/collection','text!templates/pages/news/tag.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        templateTagItem = require('text!templates/pages/news/tag.ejs');


    var NewsTagItemView = View.extend({
        autoRender: false,
        template: templateTagItem,
        className: 'tag',
        tagName: 'div',
        region: 'news-tag-region',
        listen: {
            'change:selected model': 'render'
        }
    });

    var NewsTagsView = CollectionView.extend({
        itemView: NewsTagItemView,
        autoRender: false,
        className: 'cloud-tags',
        region: 'news-tags',
        regions: {
            'news-tag-region': '#news-tags-cloud'
        }
    });

    return NewsTagsView;
});

